import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home.vue'),
      meta: {
        pid: 1,
        title: '時の広告社'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/about.vue'),
      meta: {
        pid: 2,
        title: '会社の哲学'
      }
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('./views/policy.vue'),
      meta: {
        pid: 3,
        title: '制作理念'
      }
    },
    {
      path: '/client-work',
      name: 'client-work',
      component: () => import('./views/client-work.vue'),
      meta: {
        pid: 4,
        title: '制作事例'
      }
    },
    {
      path: '/client-work-demo',
      name: 'client-work-demo',
      component: () => import('./views/client-work-demo/index.vue'),
      meta: {
        pid: 98,
        title: '制作事例'
      }
    },
    {
      path: '/client-work-demo/:id',
      name: 'product',
      component: () => import('./views/client-work-demo/product.vue')
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('./views/project.vue'),
      meta: {
        pid: 5,
        title: 'プロジェクト'
      }
    },
    {
      path: '/company',
      name: 'company',
      component: () => import('./views/company.vue'),
      meta: {
        pid: 6,
        title: '会社概要'
      }
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('./views/privacy-policy.vue'),
      meta: {
        pid: 7,
        title: 'プライバシーポリシー'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/contact.vue'),
      meta: {
        pid: 8,
        title: 'お問い合わせ'
      }
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: () => import('./views/thanks.vue'),
      meta: {
        pid: 9,
        title: '送信完了'
      }
    },
    {
      path: '/access',
      name: 'access',
      component: () => import('./views/access.vue'),
      meta: {
        pid: 10,
        title: '本社へのアクセス'
      }
    },
    {
      path: '/link',
      name: 'link',
      component: () => import('./views/link.vue'),
      meta: {
        pid: 11,
        title: 'リンク'
      }
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('./views/recruit.vue'),
      meta: {
        pid: 12,
        title: '採用情報'
      }
    },
    {
      path: '*',
      name: '404',
      component: () => import('./views/404.vue'),
      meta: {
        pid: 13,
        title: 'ページがありません'
      }
    },
    { path: '/index.html', redirect: '/' },
    { path: '/about.html', redirect: '/about' },
    { path: '/contact.html', redirect: '/contact' },
    { path: '/env.html', redirect: '/company' },
    { path: '/link.html', redirect: '/link' },
    { path: '/map.html', redirect: '/access' },
    { path: '/policy.html', redirect: '/privacy-policy' },
    { path: '/works.html', redirect: '/clientwork' },
    { path: '/yutari.html', redirect: '/project' },
    { path: '/yutariya.html', redirect: '/project' },
    { path: '/career.html', redirect: '/recruit' },
    { path: '/guid.html', redirect: '*' },
    { path: '/phil.html', redirect: '*' },
    { path: '/t_box_base.html', redirect: '*' },
    { path: '/t_box_full.html', redirect: '*' },
    { path: '/t_box.html', redirect: '*' }
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      if (savedPosition) {
        return savedPosition
      } else {
        setTimeout(() => resolve({ x: 0, y: 0 }), 700)
      }
    })
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router